/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { Colors, Link, Shadows, Typography } from '@zapier/design-system';
import type { UniversalNavLinkType } from '@zapier/universal-nav/dist/constants';

import {
  isolateComponent,
  labelStyles,
} from '@zapier/common-utils';

type Props = {
  /**
   * Array of links to render within dropdown menu.
   */
  links: Array<UniversalNavLinkType>;
};

const Styles = labelStyles(__filename, {
  root: css`
    background-color: ${Colors.white};
    border-radius: 0 0 10px 10px;
    padding: 20px;
    box-shadow: ${Shadows.elevation20};
  `,

  list: css`
    display: grid;
    grid-template-columns: 100%;
    gap: 5px;
  `,

  link: css`
    ${Typography.base};
    display: block;
    border-radius: 10px;
    color: ${Colors.black};
    line-height: 20px;
    font-size: 14px;
    padding: 10px;

    &:hover, &:focus {
      color: ${Colors.blue500};
      background-color: ${Colors.blue100};
    }
  `,

  linkInner: css`
    transform: translateY(1px);
  `,

  linkTitle: css`
    display: block;
    font-weight: 700;
  `,

  linkDescription: css`
    display: block;
    margin-top: 5px;
    color: ${Colors.grey700};
    font-size: 12px;
    line-height: 15px;
  `,
});

const SubmenuLink = (props: UniversalNavLinkType) => {
  return (
    <Link color={null} css={Styles.link} href={props.href}>
      <div css={Styles.linkInner}>
        <p css={Styles.linkTitle}>{props.text}</p>
        {props.description && (
          <p css={Styles.linkDescription}>
            {props.description}
          </p>
        )}
      </div>
    </Link>
  );
};

/**
 * Submenu component acts as a dropdown on universal nav links
 */
const Submenu = (props: Props) => {
  const linkItems = props.links.map((link) => {
    return (
      <li key={link.text}>
        <SubmenuLink {...link} />
      </li>
    );
  });
  return (
    <div css={Styles.root}>
      <ul css={Styles.list}>
        {linkItems}
      </ul>
    </div>
  );
};

export default Submenu;
